import React, { Component } from 'react';

export default class ShareBlock extends Component {

    constructor(props) {
        super(props);
    }

    reset = () => {
        this.props.resetHandle();
    };

    share = () => {
        this.props.shareHandle();
    };

    print = () => {
        this.props.printHandle();
    };

    save = () => {
        this.props.saveHandle();
    };

    render() {
        return (
            <div className="share-block">
                <div className="top">
                    <ul>
                        {app ?
                            <li onClick={this.save} className="save"><span className="icon"></span><span>Lagre resultatet</span></li>
                            :
                            <li onClick={this.print} className="print"><span className="icon"></span><span>Skriv ut resultatet</span></li>
                        }
                        <li onClick={this.share} className="share"><span className="icon"></span><span>Del resultatet</span></li>
                        <li onClick={this.reset} className="reset"><span className="icon"></span><span>Start på nytt</span></li>
                    </ul>
                </div>
                <div className="help">
                    <a href="mailto:cbh@kvale.no"><span className="icon"></span><span>Spørsmål til resultatet?</span></a>
                </div>
                <div className="terms">
                    <span className="result-terms"><strong>MERK:</strong> Ved å bruke Fristberegneren aksepterer du følgende <a href="/terms">Vilkår og betingelser</a>, herunder at bruken av Fristberegneren fullt ut skjer på eget ansvar, og at Utvikleren således ikke påtar seg ansvar for feil eller mangler av noen som helst art.
                    </span>
                </div>
            </div>

        );
    }
}


// WEBPACK FOOTER //
// ./src/components/ShareBlock.js